/* istanbul ignore file */

import { useMemo, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';
import { TemplateName } from 'src/api/learningSessions/types';
import { useDevToolPermissions } from 'src/apps/Tools/DevTools/utils';

type devToolState = {
  hasLoaded: boolean;
  showCorrectAnswer: boolean;
  forceTestType: TemplateName | null;
  currentLearnableId: number | null;
  refetchDashboard: () => void;
  communicateAutoHint: boolean;
};

const init: devToolState = {
  hasLoaded: false,
  showCorrectAnswer: false,
  forceTestType: null,
  currentLearnableId: null,
  refetchDashboard: () => {},
  communicateAutoHint: false,
};

// eslint-disable-next-line
let globalSetDevTools: any = (_newState: devToolState) => {
  throw new Error('you must call useDevTools before setting its state');
};

/**
 * Hook to retrieve the dev tools state
 */
export const useDevTools = singletonHook(init, () => {
  const [devTools, setDevTools] = useState<devToolState>(init);

  if (!useDevToolPermissions()) return null;

  globalSetDevTools = setDevTools;

  return useMemo(
    () => ({
      ...devTools,
      hasLoaded: true,
    }),
    [devTools],
  );
});

/**
 * Hook to set the dev tools state
 */
export const setDevTools = (newState: devToolState) => globalSetDevTools(newState);
